import { render, staticRenderFns } from "./SkillcourtEuroParcsLayout.vue?vue&type=template&id=8c0ff652&scoped=true&"
import script from "./SkillcourtEuroParcsLayout.vue?vue&type=script&lang=js&"
export * from "./SkillcourtEuroParcsLayout.vue?vue&type=script&lang=js&"
import style0 from "./SkillcourtEuroParcsLayout.vue?vue&type=style&index=0&id=8c0ff652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0ff652",
  null
  
)

export default component.exports